import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";

import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { FcSalesPerformance } from "react-icons/fc";
// import PriceWatcherViewTable from "./price_watcher_view_table";
import PriceWatcherViewTable from "./price_watcher_scrapper_view_table";
import Pagination from "../../../Components/layouts/pagination";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

const ViewPriceWatcherScrapper = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [chartPage, setChartPageData] = useState();
  let { alphaPlantId } = useParams();
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        setLoading(true);

        const res = await performRequest(
          "GET",
          `/priceWatcherScrapper/getAllPriceScrapperByAlphaId/${alphaPlantId}`
        );

        if (res.status === 200) {
          setData(res.data);
          setLoading(false);
        } else {
          Toast("error", "Error while getting data!");
        }
      } catch (err) {
        CustomErrorResponse(err);
      }
    };

    fetchData();
  }, [refresh, page, alphaPlantId]);

  const SortedData = chartPage?.sort((a, b) => {
    if (a.createdAt > b.createdAt) return -1;
    if (a.createdAt < b.createdAt) return 1;
    return 0;
  });

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcSalesPerformance className="fs-2  me-1" />
                  {data?.getAllPlantData[0]?.alphaPlantName} Price Scrapper
                </h2>
                <h4 className="text-muted">
                  {/* <StepRoutes /> */} Track different commodities and there
                  pricing.
                </h4>
              </div>
              <div className="col-md-4"></div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4 col-sm-12 py-2">
              <div className="card">
                <div class="table-responsive">
                  <table class="table table-vcenter card-table table-striped">
                    <thead>
                      <tr>
                        <th>Specs.</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data && (
                        <tr>
                          <td>Alpha Plant Id</td>
                          <td>
                            {data?.getAllPlantData[0]?.alphaPlantId || "N/A"}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Alpha Plant Name</td>
                          <td>
                            {data?.getAllPlantData[0]?.alphaPlantName || "N/A"}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Scrapp Source</td>
                          <td>
                            {data?.getAllPlantData[0]?.scrapSource || "N/A"}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Scrapp Date</td>
                          <td>
                            {data?.getAllPlantData[0]?.scrapDate || "N/A"}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Plant Weight</td>
                          <td>
                            {data?.getAllPlantData[0]?.plantWeight || "N/A"}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Plant Price</td>
                          <td>
                            ₹{data?.getAllPlantData[0]?.plantPrice || "N/A"}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Scrap Url</td>
                          <td>
                            {data?.getAllPlantData[0]?.scrapUrl &&
                            data?.getAllPlantData[0]?.scrapUrl !== "N/A" ? (
                              <a
                                href={data.getAllPlantData[0].scrapUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#0d6efd",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                onMouseEnter={(e) =>
                                  (e.target.style.color = "#084298")
                                }
                                onMouseLeave={(e) =>
                                  (e.target.style.color = "#0d6efd")
                                }
                              >
                                {data.getAllPlantData[0].scrapUrl}
                              </a>
                            ) : (
                              <span
                                style={{
                                  color: "#6c757d",
                                  cursor: "not-allowed",
                                }}
                              >
                                N/A
                              </span>
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="card mt-3 border-0">
                <div className="card-body p-0">
                  <img
                    className="d-none d-sm-block"
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752556072/1_vyhuj0_b1uh26_tcvj3t.jpg"
                    alt="plantvisittoday"
                  />
                </div>
              </div>
              <div className="card p-2 mb-3 mt-3 d-none d-sm-block">
                <h3 className="m-0 p-0">Disclaimer :</h3>
                <hr className="m-1" />
                <div className="p-1">
                  <p className="p-0 m-0">
                    The agricultural commodity price trends provided are for
                    informational purposes only and should not be considered as
                    financial or investment advice. This data is processed and
                    refined using AI and may not always reflect real-time market
                    conditions with complete accuracy. While we strive to
                    provide reliable insights, we do not guarantee the absolute
                    correctness of the information. Users are strongly advised
                    to conduct their own market research and consult with
                    industry professionals before making any financial or
                    business decisions. We are not liable for any losses or
                    consequences resulting from reliance on this data.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-8 col-sm-12 py-2">
              <div className="card">
                {
                  <PriceWatcherViewTable
                    data={data?.getAllPlantData}
                    currentPage={page}
                    itemsPerPage={50}
                    refresh={refresh}
                    setRefresh={setRefresh}
                  />
                }
                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageDatalength={SortedData?.length || 0}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewPriceWatcherScrapper;
